import React from 'react'

import { SvgProps } from './types'

function ToolsSvg({
  width,
  height,
  className,
  size,
  styles,
  stroke,
  fill,
}: SvgProps) {
  const { innerWidth } = window
  const defaultWidth = innerWidth > 1024 ? 's' : 'm'
  const sizeKey = typeof size === 'undefined' ? defaultWidth : size

  const scale = {
    xl: 3.0,
    lg: 2.5,
    m: 1.0,
    s: 0.8,
    xs: 0.5,
  }

  return (
    <svg
      className={className}
      style={{
        ...styles,
        ...{
          transform: `scale(${scale[sizeKey]})`,
        },
      }}
      width={width || '48'}
      height={height || '48'}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      strokeWidth={stroke || 1}
    >
      <g opacity="0.65">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.1085 13.4351C14.499 13.8257 14.499 14.4588 14.1085 14.8493L4.68038 24.2774C4.02951 24.9283 4.02951 25.9836 4.68038 26.6345C5.33126 27.2853 6.38653 27.2853 7.03741 26.6345L16.4655 17.2064C16.856 16.8158 17.4892 16.8158 17.8797 17.2064C18.2702 17.5969 18.2702 18.2301 17.8797 18.6206L8.45162 28.0487C7.0197 29.4806 4.69809 29.4806 3.26617 28.0487C1.83425 26.6168 1.83425 24.2951 3.26617 22.8632L12.6943 13.4351C13.0848 13.0446 13.7179 13.0446 14.1085 13.4351Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.3381 18.3563C14.9475 18.7468 14.9475 19.38 15.3381 19.7705L23.616 28.0484C25.0479 29.4804 27.3695 29.4804 28.8015 28.0484C30.2334 26.6165 30.2334 24.2949 28.8015 22.863L23.6304 17.6919C23.2399 17.3014 22.6067 17.3014 22.2162 17.6919C21.8257 18.0825 21.8257 18.7156 22.2162 19.1061L27.3872 24.2772C28.0381 24.9281 28.0381 25.9833 27.3872 26.6342C26.7364 27.2851 25.6811 27.2851 25.0302 26.6342L16.7523 18.3563C16.3618 17.9657 15.7286 17.9657 15.3381 18.3563Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.4571 12.3525C13.8476 11.962 13.8476 11.3288 13.4571 10.9383L10.1204 7.60168L10.8678 5.35957C11.016 4.91493 10.8355 4.427 10.4336 4.18585L5.71958 1.35742C5.3261 1.12134 4.82244 1.18334 4.49797 1.50781L2.61236 3.39343C2.28789 3.7179 2.22588 4.22156 2.46197 4.61503L5.2904 9.32908C5.53154 9.73098 6.01947 9.91148 6.46412 9.76326L8.70623 9.01589L12.0428 12.3525C12.4334 12.743 13.0665 12.743 13.4571 12.3525ZM8.18575 7.0812L6.59267 7.61223L4.57866 4.25555L5.36009 3.47412L8.71677 5.48812L8.18575 7.0812Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.6643 6.54974C27.3586 6.51211 27.0527 6.6174 26.835 6.83514L23.0368 10.6333L20.4442 10.8688L20.6798 8.27632L24.478 4.47812C24.6957 4.26037 24.801 3.95446 24.7634 3.64883C24.7257 3.3432 24.5494 3.07195 24.2853 2.91352C22.8531 2.05415 20.9428 1.82569 19.1346 2.08842C17.3155 2.35273 15.4507 3.13446 14.1071 4.47812C11.4239 7.1613 11.2469 11.3889 12.4689 14.5068C12.6704 15.021 13.2506 15.2745 13.7648 15.073C14.279 14.8714 14.5325 14.2912 14.331 13.777C13.3028 11.1536 13.5657 7.84786 15.5213 5.89233C16.497 4.91663 17.932 4.28415 19.4222 4.06764C20.3424 3.93394 21.2277 3.96643 21.9882 4.13942L19.0095 7.11814C18.8441 7.28357 18.7419 7.50177 18.7207 7.73477L18.3439 11.8828C18.3171 12.1784 18.4229 12.4706 18.6327 12.6804C18.8425 12.8902 19.1347 12.996 19.4303 12.9692L23.5783 12.5924C23.8113 12.5712 24.0295 12.469 24.195 12.3036L27.1737 9.32487C27.3467 10.0854 27.3792 10.9707 27.2455 11.8909C27.0289 13.3811 26.3965 14.8161 25.4208 15.7918C23.4652 17.7474 20.1595 18.0103 17.5361 16.9821C17.0219 16.7806 16.4417 17.034 16.2401 17.5482C16.0386 18.0624 16.2921 18.6427 16.8063 18.8442C19.9242 20.0662 24.1518 19.8892 26.835 17.206C28.1786 15.8624 28.9604 13.9976 29.2247 12.1785C29.4874 10.3703 29.2589 8.46004 28.3996 7.02775C28.2411 6.7637 27.9699 6.58736 27.6643 6.54974Z"
          fill={fill}
        />
      </g>
    </svg>
  )
}

export default ToolsSvg
